<template lang="pug">
  #navbar
    nav#bar.navbar.d-flex
      .navbar-brand.story.desktop
        a(href="#intro")
          img(src="/assets/img/chapter1/title.png")
      .navbar-brand.story.desktop-xl
        a(href="#intro")
          img(src="/assets/img/chapter1/title.png")
      p.desktop-xl.bar-title.smaller.neutral-text.mr-3.mb-0 Todo lo que necesitas
        br 
        span.bolder SABER SOBRE 
        span.bolder.accent-text EL CORONAVIRUS
      ul.navbar-nav.mr-auto
        b-nav-item-dropdown(:text="activeSection" right)
          b-dropdown-item.neutral-text(href="#section1") Primero lo primero, ¿qué es un virus?
          b-dropdown-item.neutral-text(href="#section2") Y ¿qué son los coronavirus en específico?
          b-dropdown-item.neutral-text(href="#section3") ¿Y el COVID-19?
          b-dropdown-item.neutral-text(href="#section4") ¿Cómo entra y evoluciona el SARS-CoV-2 en el cuerpo humano?
          b-dropdown-item.neutral-text(href="#section5") Las etapas del virus pueden dividirse
          b-dropdown-item.neutral-text(href="#section6") ¿Cómo es el COVID-19 diferente de la influenza?
          b-dropdown-item.neutral-text(href="#section7") Créditos y bibliografía
      .navbar-brand.viral
        router-link(to="/")
          img(src="/assets/img/logo.png")
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      sections: {
        section1: "Primero lo primero, ¿qué es un virus?",
        section2: "Y ¿qué son los coronavirus en específico?",
        section3: "¿Y el COVID-19?",
        section4: "¿Cómo entra y evoluciona el SARS-CoV-2 en el cuerpo humano?",
        section5: "Las etapas del virus pueden dividirse",
        section6: "¿Cómo es el COVID-19 diferente de la influenza?",
        section7: "Créditos y bibliografía"
      }
    };
  },
  computed: {
    sectionId() {
      return this.$store.state.chapter1.sectionId;
    },
    activeSection() {
      return this.sections[this.sectionId];
    }
  },
  methods: {
    onScroll() {
      var prevScrollpos = window.pageYOffset;
      window.addEventListener("scroll", () => {
        const navbar = document.getElementById("bar");
        if (
          document.body.scrollTop > 1300 ||
          document.documentElement.scrollTop > 1300
        ) {
          navbar.style.top = "0";
          let currentScrollPos = window.pageYOffset;
          if (prevScrollpos > currentScrollPos) {
            navbar.style.top = "0";
          } else {
            navbar.style.top = "-100px";
          }
          prevScrollpos = currentScrollPos;
        } else {
          navbar.style.top = "-100px";
        }
      });
    }
  },
  mounted() {
    this.onScroll();
  }
};
</script>

<style lang="scss">
#navbar {
  .navbar {
    height: 100px;
    position: fixed;
    top: -100px;
    width: 100%;
    display: block;
    transition: top 0.5s;
    z-index: 100;
  }
}
</style>
